import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  Drzava,
  KucniBroj,
  Mjesto,
  Okrug,
  PostanskiBroj,
  Regija,
  Ulica,
} from "../../../index";
import RemoveIcon from "@mui/icons-material/Remove";
import { useFieldArray } from "react-hook-form";

const Index = ({ nazivPolja }: { nazivPolja: string }) => {
  const { fields, append, remove } = useFieldArray({
    name: nazivPolja,
    keyName: "key",
  });

  const dodaj = () => {
    append({
      drzava: { oznaka: "", euSifra: "" },
      mjesto: "",
    });
  };

  const ukloni = (index: number) => {
    remove(index);
  };

  return (
    <>
      {fields.map((field: any, index) => (
        <Card
          variant={"outlined"}
          sx={{ mt: 3, position: "relative" }}
          key={field.id}
        >
          <CardHeader
            title={"Adresa (Address)"}
            titleTypographyProps={{ variant: "h6" }}
            action={
              <>
                {fields.length > 1 && (
                  <Tooltip title={"Ukloni (Remove)"}>
                    <IconButton
                      aria-label="settings"
                      onClick={() => ukloni(index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title={"Dodaj  (Add)"}>
                  <Fab
                    size={"small"}
                    aria-label="settings"
                    onClick={dodaj}
                    disabled={fields.length >= 10}
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
              </>
            }
          ></CardHeader>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ mb: 2 }}>
                <Drzava
                  label={"*Država (Country)"}
                  nazivPolja={`${nazivPolja}[${index}].drzava.oznaka`}
                  nazivPoljaEu={`${nazivPolja}[${index}].drzava.euSifra`}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Mjesto nazivPolja={`${nazivPolja}[${index}].mjesto`} />
              </Grid>
              <Grid item xs={6}>
                <Regija nazivPolja={`${nazivPolja}[${index}].regija`} />
              </Grid>
              <Grid item xs={6}>
                <PostanskiBroj
                  nazivPolja={`${nazivPolja}[${index}].postanskiBroj`}
                />
              </Grid>
              <Grid item xs={6}>
                <Okrug nazivPolja={`${nazivPolja}[${index}].okrug`} />
              </Grid>
              <Grid item xs={6}>
                <Ulica nazivPolja={`${nazivPolja}[${index}].ulica`} />
              </Grid>
              <Grid item xs={6}>
                <KucniBroj nazivPolja={`${nazivPolja}[${index}].kucniBroj`} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Index;
